import React from 'react';
import { Box, Skeleton } from '@mui/material';

function DetailSkeleton() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: '5rem',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '920px',
          marginTop: 'calc(3rem + 76px)',
          marginLeft: '4rem',
          height: '100%',
          flexDirection: 'column',
          gap: '2.5rem'
        }}>
        {/* Título */}
        <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <Skeleton variant="circular" width={24} height={24} animation="wave" />
          <Skeleton variant="text" width={200} height={40} animation="wave" />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {/* Primer Box */}
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="100%"
            height={118}
            sx={{
              borderRadius: '1rem'
            }}
          />

          {/* Segundo Box */}
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="100%"
            height="500px"
            sx={{
              borderRadius: '1rem',
              padding: '1.5rem'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default DetailSkeleton;
